export default [
    'To be filled in by Supplier',
    'To be corrected by Supplier',
    'To be approved by PMI',
    'Approved by PMI',
    'Completed',
    'Processing not applicable'
]